import { Link } from "react-router-dom";
import { ArrowRight, Trophy } from "lucide-react";
import { IMG, waLink } from "@/lib/brand";

const stats = [
  { value: "95%+", label: "Highest Marks" },
  { value: "500+", label: "Students Mentored" },
  { value: "100%", label: "Pass Rate" },
  { value: "50+", label: "School Toppers" },
];

const achievers = [
  { name: "Aarav Kumar", cls: "Class X CBSE", marks: "98%", quote: "Vikramshila made every concept crystal clear.", img: IMG.studentMale },
  { name: "Priya Singh", cls: "Class X ICSE", marks: "96%", quote: "Weekly tests kept me on track.", img: IMG.studentFemale },
  { name: "Rohan Verma", cls: "Class IX", marks: "95%", quote: "Best coaching in Rajeev Nagar.", img: IMG.studentMale },
  { name: "Ananya Sharma", cls: "Class X CBSE", marks: "94%", quote: "Doubt sessions helped me the most.", img: IMG.studentFemale },
  { name: "Aditya Raj", cls: "Class VIII", marks: "93%", quote: "I love the way my teacher teaches Maths.", img: IMG.studentMale },
  { name: "Kavya Mishra", cls: "Class X", marks: "92%", quote: "Personal mentoring changed everything.", img: IMG.studentFemale },
];

const yearly = [
  { y: "2025", n: "42 students above 90%" },
  { y: "2024", n: "38 students above 90%" },
  { y: "2023", n: "31 students above 90%" },
];

export default function ResultsPage() {
  return (
    <div>
      <section className="bg-[#0B192C] text-white relative overflow-hidden">
        <div className="vk-grain" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <span className="vk-chip">Results</span>
          <h1 className="mt-4 font-display text-5xl sm:text-6xl font-800 tracking-tight max-w-3xl">Our results speak for themselves.</h1>
          <p className="mt-5 max-w-2xl text-lg text-white/70">Every year, Vikramshila students set new benchmarks in their schools and their boards.</p>
          <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4">
            {stats.map((s)=>(
              <div key={s.label} className="rounded-lg bg-white/5 border border-white/10 p-6">
                <div className="font-display text-4xl sm:text-5xl font-800 text-[#FF6B35]">{s.value}</div>
                <div className="mt-2 text-xs uppercase tracking-widest text-white/60">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="vk-chip">Top performers</span>
          <h2 className="mt-4 font-display text-4xl font-800 text-[#0B192C]">Some of our recent achievers</h2>
          <p className="mt-3 text-slate-600 max-w-2xl">A few of the many faces behind our board exam success stories. Real photos and marks will replace placeholders as new results come in.</p>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {achievers.map((a,i)=>(
              <div key={a.name} data-testid={`achiever-${i}`} className="rounded-lg border border-slate-200 overflow-hidden bg-white flex flex-col">
                <div className="aspect-[4/3] overflow-hidden bg-slate-100">
                  <img src={a.img} alt={`${a.name} — ${a.cls} achiever at Vikramshila Classes`} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <div className="flex items-center gap-2 text-[#FF6B35]"><Trophy size={16} /><span className="text-sm font-semibold">{a.marks}</span></div>
                  <div className="mt-2 font-display text-xl font-bold text-[#0B192C]">{a.name}</div>
                  <div className="text-sm text-slate-500">{a.cls}</div>
                  <p className="mt-3 text-slate-700 italic">&ldquo;{a.quote}&rdquo;</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="vk-chip">Year on year</span>
          <h2 className="mt-4 font-display text-4xl font-800 text-[#0B192C]">Board toppers, every session</h2>
          <div className="mt-8 divide-y divide-slate-200 border border-slate-200 rounded-lg bg-white">
            {yearly.map((y)=>(
              <div key={y.y} className="p-6 flex items-center justify-between">
                <div className="font-display text-2xl font-800 text-[#0B192C]">{y.y}</div>
                <div className="text-slate-700">{y.n}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-[#0B192C] text-white relative overflow-hidden">
        <div className="vk-grain" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display text-4xl font-800">Be our next topper.</h2>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link to="/contact" className="vk-btn-primary">Enroll Now <ArrowRight size={16} /></Link>
            <a href={waLink()} target="_blank" rel="noreferrer" className="vk-btn-outline">WhatsApp Now</a>
          </div>
        </div>
      </section>
    </div>
  );
}
